(() => {
  'use strict';

  const paletteCategories = [
    {
      id: 'neon-digital',
      title: 'Neon és digitális',
      description:
        'Erős, modern és technológiai színrendszerek.',
      palettes: [
        {
          id: 'digital-lime',
          name: 'Digital Lime',
          colors: {
            background: '#F4F5EF',
            surface: '#FFFFFF',
            text: '#11140F',
            primary: '#BDF35A',
            secondary: '#BCA8FF'
          }
        },
        {
          id: 'cyber-blue',
          name: 'Cyber Blue',
          colors: {
            background: '#07131F',
            surface: '#0E2133',
            text: '#F5FAFF',
            primary: '#63D8FF',
            secondary: '#A7FF5A'
          }
        },
        {
          id: 'electric-purple',
          name: 'Electric Purple',
          colors: {
            background: '#120C1C',
            surface: '#1D132A',
            text: '#F8F4FF',
            primary: '#C8A2FF',
            secondary: '#6FFFE9'
          }
        },
        {
          id: 'signal-yellow',
          name: 'Signal Yellow',
          colors: {
            background: '#13130D',
            surface: '#222216',
            text: '#F7F7EA',
            primary: '#E4F255',
            secondary: '#93CEFF'
          }
        },
        {
          id: 'pulse-pink',
          name: 'Pulse Pink',
          colors: {
            background: '#170D14',
            surface: '#281622',
            text: '#FFF5FB',
            primary: '#FF72C6',
            secondary: '#A8FF78'
          }
        },
        {
          id: 'infra-red',
          name: 'Infra Red',
          colors: {
            background: '#190B0B',
            surface: '#2B1212',
            text: '#FFF7F2',
            primary: '#FF5C4D',
            secondary: '#F5E663'
          }
        },
        {
          id: 'mint-grid',
          name: 'Mint Grid',
          colors: {
            background: '#071511',
            surface: '#10231D',
            text: '#EFFFF8',
            primary: '#77FFCA',
            secondary: '#8AB4FF'
          }
        },
        {
          id: 'cobalt-neon',
          name: 'Cobalt Neon',
          colors: {
            background: '#0C1020',
            surface: '#161C34',
            text: '#F4F7FF',
            primary: '#4F7CFF',
            secondary: '#BDF35A'
          }
        },
        {
          id: 'acid-orange',
          name: 'Acid Orange',
          colors: {
            background: '#17110A',
            surface: '#2A1C0E',
            text: '#FFF6E8',
            primary: '#FF8A34',
            secondary: '#D7FF4F'
          }
        },
        {
          id: 'aqua-violet',
          name: 'Aqua Violet',
          colors: {
            background: '#08171A',
            surface: '#10282D',
            text: '#F1FFFF',
            primary: '#57E8E8',
            secondary: '#C3A2FF'
          }
        }
      ]
    },
    {
      id: 'premium-luxury',
      title: 'Prémium és luxus',
      description:
        'Mély tónusok, elegáns kontrasztok és visszafogott akcentusok.',
      palettes: [
        {
          id: 'noir-gold',
          name: 'Noir Gold',
          colors: {
            background: '#0F0F0D',
            surface: '#1B1A16',
            text: '#F4F0E6',
            primary: '#C6A15B',
            secondary: '#8D6E3C'
          }
        },
        {
          id: 'ivory-onyx',
          name: 'Ivory Onyx',
          colors: {
            background: '#F5F1E8',
            surface: '#FFFFFA',
            text: '#171512',
            primary: '#1E1E1B',
            secondary: '#B99B63'
          }
        },
        {
          id: 'burgundy-silk',
          name: 'Burgundy Silk',
          colors: {
            background: '#1A0C10',
            surface: '#2B1119',
            text: '#FBEFF2',
            primary: '#B84C66',
            secondary: '#D9B26F'
          }
        },
        {
          id: 'emerald-brass',
          name: 'Emerald Brass',
          colors: {
            background: '#091713',
            surface: '#11251F',
            text: '#EEF8F3',
            primary: '#2E8B68',
            secondary: '#C4A35A'
          }
        },
        {
          id: 'midnight-pearl',
          name: 'Midnight Pearl',
          colors: {
            background: '#0A101B',
            surface: '#111A2A',
            text: '#F4F7FB',
            primary: '#6C86B6',
            secondary: '#D7DDE8'
          }
        },
        {
          id: 'cocoa-cream',
          name: 'Cocoa Cream',
          colors: {
            background: '#241712',
            surface: '#34211A',
            text: '#F8EFE8',
            primary: '#B97850',
            secondary: '#E7C7A9'
          }
        },
        {
          id: 'slate-silver',
          name: 'Slate Silver',
          colors: {
            background: '#16191D',
            surface: '#23272C',
            text: '#F7F8FA',
            primary: '#8F9AA8',
            secondary: '#DDE3EA'
          }
        },
        {
          id: 'plum-champagne',
          name: 'Plum Champagne',
          colors: {
            background: '#1A101A',
            surface: '#2A182A',
            text: '#F9F1F8',
            primary: '#9C5C92',
            secondary: '#E3C59A'
          }
        },
        {
          id: 'olive-leather',
          name: 'Olive Leather',
          colors: {
            background: '#15170F',
            surface: '#25291A',
            text: '#F3F3E7',
            primary: '#7B8745',
            secondary: '#C6A56B'
          }
        },
        {
          id: 'monochrome-studio',
          name: 'Monochrome Studio',
          colors: {
            background: '#F4F4F1',
            surface: '#FFFFFF',
            text: '#111111',
            primary: '#292929',
            secondary: '#B7B7B2'
          }
        }
      ]
    },
    {
      id: 'natural-organic',
      title: 'Természetes és organikus',
      description:
        'Földszínek, növényi tónusok és nyugodt, természetes felületek.',
      palettes: [
        {
          id: 'sage-clay',
          name: 'Sage Clay',
          colors: {
            background: '#F2F0E7',
            surface: '#FBF9F2',
            text: '#2E352D',
            primary: '#80936B',
            secondary: '#C98768'
          }
        },
        {
          id: 'forest-moss',
          name: 'Forest Moss',
          colors: {
            background: '#0D1710',
            surface: '#17251B',
            text: '#EDF6EE',
            primary: '#5B7C58',
            secondary: '#B9C47A'
          }
        },
        {
          id: 'sand-terracotta',
          name: 'Sand Terracotta',
          colors: {
            background: '#F4EBDD',
            surface: '#FDF8F0',
            text: '#3A2D24',
            primary: '#C9794A',
            secondary: '#D8B87A'
          }
        },
        {
          id: 'alpine-blue',
          name: 'Alpine Blue',
          colors: {
            background: '#ECF2F1',
            surface: '#F8FBFA',
            text: '#203234',
            primary: '#5E8B8D',
            secondary: '#A8C0A5'
          }
        },
        {
          id: 'olive-stone',
          name: 'Olive Stone',
          colors: {
            background: '#EBE9DD',
            surface: '#F5F3E9',
            text: '#2A2D22',
            primary: '#7E875B',
            secondary: '#AFA78E'
          }
        },
        {
          id: 'botanical-cream',
          name: 'Botanical Cream',
          colors: {
            background: '#F6F1E5',
            surface: '#FFFFFA',
            text: '#233127',
            primary: '#4B7A5A',
            secondary: '#E6B85D'
          }
        },
        {
          id: 'desert-rose',
          name: 'Desert Rose',
          colors: {
            background: '#F5E8E2',
            surface: '#FFF7F4',
            text: '#3D2927',
            primary: '#B96D62',
            secondary: '#D7A67E'
          }
        },
        {
          id: 'earth-sky',
          name: 'Earth & Sky',
          colors: {
            background: '#E9EEE8',
            surface: '#F7FAF6',
            text: '#25342E',
            primary: '#547A6A',
            secondary: '#7EA0B6'
          }
        },
        {
          id: 'pine-linen',
          name: 'Pine Linen',
          colors: {
            background: '#EDEAE0',
            surface: '#F9F7F0',
            text: '#223027',
            primary: '#385F48',
            secondary: '#C5B998'
          }
        },
        {
          id: 'meadow-sun',
          name: 'Meadow Sun',
          colors: {
            background: '#F3F4E7',
            surface: '#FCFCF6',
            text: '#2F3625',
            primary: '#86A84A',
            secondary: '#DCCB55'
          }
        }
      ]
    },
    {
      id: 'clean-technical',
      title: 'Tiszta és technikai',
      description:
        'Precíz, világos és rendszerezett vizuális kombinációk.',
      palettes: [
        {
          id: 'arctic-blue',
          name: 'Arctic Blue',
          colors: {
            background: '#F3F7FA',
            surface: '#FFFFFF',
            text: '#10202C',
            primary: '#2E7DB2',
            secondary: '#8DC8E8'
          }
        },
        {
          id: 'graphite-cyan',
          name: 'Graphite Cyan',
          colors: {
            background: '#0F151A',
            surface: '#182129',
            text: '#F2F7F9',
            primary: '#38B8C6',
            secondary: '#86D8DF'
          }
        },
        {
          id: 'cloud-navy',
          name: 'Cloud Navy',
          colors: {
            background: '#F1F4F8',
            surface: '#FFFFFF',
            text: '#142033',
            primary: '#315A8A',
            secondary: '#A3B9D3'
          }
        },
        {
          id: 'white-signal',
          name: 'White Signal',
          colors: {
            background: '#F7F8F5',
            surface: '#FFFFFF',
            text: '#161B17',
            primary: '#84C83C',
            secondary: '#273B55'
          }
        },
        {
          id: 'data-violet',
          name: 'Data Violet',
          colors: {
            background: '#F5F3FA',
            surface: '#FFFFFF',
            text: '#1B1822',
            primary: '#7163C6',
            secondary: '#A7C9FF'
          }
        },
        {
          id: 'steel-orange',
          name: 'Steel Orange',
          colors: {
            background: '#F0F2F3',
            surface: '#FFFFFF',
            text: '#20262B',
            primary: '#E17635',
            secondary: '#6F8290'
          }
        },
        {
          id: 'ice-green',
          name: 'Ice Green',
          colors: {
            background: '#F1F7F4',
            surface: '#FFFFFF',
            text: '#163028',
            primary: '#2E9D78',
            secondary: '#8FDCC0'
          }
        },
        {
          id: 'blueprint',
          name: 'Blueprint',
          colors: {
            background: '#EEF3F8',
            surface: '#F9FCFF',
            text: '#12243A',
            primary: '#2767A8',
            secondary: '#7FA7D1'
          }
        },
        {
          id: 'lab-red',
          name: 'Lab Red',
          colors: {
            background: '#F5F5F3',
            surface: '#FFFFFF',
            text: '#191B1D',
            primary: '#C4483E',
            secondary: '#5C6670'
          }
        },
        {
          id: 'carbon-white',
          name: 'Carbon White',
          colors: {
            background: '#F2F2F0',
            surface: '#FFFFFF',
            text: '#101010',
            primary: '#444444',
            secondary: '#9AA0A6'
          }
        }
      ]
    },
    {
      id: 'warm-expressive',
      title: 'Meleg és karakteres',
      description:
        'Kifejező, editorial és energikus színvilágok.',
      palettes: [
        {
          id: 'coral-plum',
          name: 'Coral Plum',
          colors: {
            background: '#FDF0EB',
            surface: '#FFF8F5',
            text: '#3B2026',
            primary: '#E36F5C',
            secondary: '#8B4B7A'
          }
        },
        {
          id: 'sunset-orange',
          name: 'Sunset Orange',
          colors: {
            background: '#FFF1E5',
            surface: '#FFF9F2',
            text: '#3B2316',
            primary: '#FF7A35',
            secondary: '#F6C557'
          }
        },
        {
          id: 'berry-cream',
          name: 'Berry Cream',
          colors: {
            background: '#F8EBF0',
            surface: '#FFF7FA',
            text: '#3D1D2E',
            primary: '#B84D7A',
            secondary: '#E5A8C1'
          }
        },
        {
          id: 'lavender-ink',
          name: 'Lavender Ink',
          colors: {
            background: '#F2EDFA',
            surface: '#FBF9FF',
            text: '#261E38',
            primary: '#8E68C8',
            secondary: '#D3BDF2'
          }
        },
        {
          id: 'peach-olive',
          name: 'Peach Olive',
          colors: {
            background: '#F8EFE3',
            surface: '#FFFAF4',
            text: '#352C20',
            primary: '#E99664',
            secondary: '#7C8B59'
          }
        },
        {
          id: 'cherry-blue',
          name: 'Cherry Blue',
          colors: {
            background: '#F9E9E9',
            surface: '#FFF7F7',
            text: '#351B1B',
            primary: '#C95050',
            secondary: '#4D6E9D'
          }
        },
        {
          id: 'amber-teal',
          name: 'Amber Teal',
          colors: {
            background: '#F9F0DF',
            surface: '#FFF9EE',
            text: '#332816',
            primary: '#D99A31',
            secondary: '#2F7772'
          }
        },
        {
          id: 'rose-cobalt',
          name: 'Rose Cobalt',
          colors: {
            background: '#F9EAF0',
            surface: '#FFF8FB',
            text: '#2D1F2A',
            primary: '#D76895',
            secondary: '#4768C8'
          }
        },
        {
          id: 'paprika-mint',
          name: 'Paprika Mint',
          colors: {
            background: '#F7E9E2',
            surface: '#FFF8F3',
            text: '#33221C',
            primary: '#C9633F',
            secondary: '#7FAF9A'
          }
        },
        {
          id: 'wine-lemon',
          name: 'Wine Lemon',
          colors: {
            background: '#F5E9EC',
            surface: '#FEF8F8',
            text: '#321923',
            primary: '#8E3F58',
            secondary: '#DED85F'
          }
        }
      ]
    }
  ];

  const customColorDefinitions = [
    {
      key: 'background',
      name: 'Háttérszín',
      role: 'Oldal alapja',
      defaultValue: '#F1F1EB'
    },
    {
      key: 'surface',
      name: 'Felület / kártya',
      role: 'Panelek és kártyák',
      defaultValue: '#FFFFFF'
    },
    {
      key: 'text',
      name: 'Szövegszín',
      role: 'Címek és törzsszöveg',
      defaultValue: '#11140F'
    },
    {
      key: 'primary',
      name: 'Elsődleges akcentus',
      role: 'Gombok és kiemelések',
      defaultValue: '#BDF35A'
    },
    {
      key: 'secondary',
      name: 'Másodlagos akcentus',
      role: 'Címkék és részletek',
      defaultValue: '#BCA8FF'
    }
  ];

  window.ZLN_LABOR_COLOR_DATA = {
    version: 1,
    paletteCategories,
    customColorDefinitions
  };

  document.dispatchEvent(
    new CustomEvent('zln:labor-color-data-ready', {
      detail: {
        version: 1,
        paletteCount: paletteCategories.reduce(
          (total, category) => {
            return total + category.palettes.length;
          },
          0
        )
      }
    })
  );
})();